import { render } from "./ApTable.vue?vue&type=template&id=143b6496&scoped=true&ts=true"
import script from "./ApTable.vue?vue&type=script&lang=ts"
export * from "./ApTable.vue?vue&type=script&lang=ts"

import "./ApTable.vue?vue&type=style&index=0&id=143b6496&lang=scss&scoped=true"

import exportComponent from "C:\\BuildAgent\\work\\7605b49a72e2e39\\AutoProc\\Solution\\Clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-143b6496"]])

export default __exports__